import router from "./router";
import {createApp} from "vue";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { createPinia } from "pinia";
import {useAuthStore} from "./store/auth";
import Application from "./Application";
import 'vue-select/dist/vue-select.css';

window._ = require('lodash');
const app = createApp(Application);

import VueZoomer from 'vue-zoomer/src'

app.use(VueZoomer)
app.use(VueToast);
app.use(createPinia());
const authStore = useAuthStore();

(async () => {
    await authStore.init();
    app.use(router);
    app.mount('#app');
})();
